import React from 'react';

function ContactSupport() {
    return (
        <>
            <div className='py-5 px-6 mt-6 whiteBox is-flex is-flex-direction-column is-justify-content-center is-justify-content-center'>
                <h3 className='py-2 m-0'>Get support</h3>
                <p className='pb-5 mb-0'>For questions and examples on how to use Nudgemail, visit our <a href="/how-to" className='textLink'>How to guide</a>.</p>

                <p className='pb-5 mb-0'>For immediate requests, send an email to <a href="mailto:support@nudgemail.com" className='textLink'>support@nudgemail.com</a>.</p>

                <p className='pb-5 mb-0'>For current Nudgemail customers who want to make us happy, <a href="/upgrade" className='textLink'>upgrade today</a>.</p>

                <p className='pb-2 mb-0'>Have an idea or feature request? Send an email to <a href="mailto:ihaveadream@nudgemail.com" className='textLink'>ihaveadream@nudgemail.com</a>.</p>
            </div>
        </>
    )
}

export default ContactSupport;